import {ReactElement} from "react";
import {PageFragment} from "../../../shared/PageFragment";
import {StyledBoxColumn} from "../../../shared/StyledComponents";
import {DIVIDER, PD_MD, PD_XLG, PD_XLG2, SZ_SMD} from "../../../shared/dimens";
import {Button, Grid, SvgIcon, Typography} from "@mui/material";
import {DatasetOutlined, SettingsOutlined} from "@mui/icons-material";

type HomeLink = {
  text: string,
  url: string,
  iconType: typeof SvgIcon,
}

const HOME_LINKS: HomeLink[] = [
  {
    text: "Datasets",
    url: "datasets",
    iconType: DatasetOutlined,
  },
  {
    text: "Settings",
    url: "settings",
    iconType: SettingsOutlined,
  },
];

export class DashboardFragment extends PageFragment {

  protected getTitle(): string | null | undefined {
    return "Dashboard";
  }

  renderContent(): ReactElement {
    return <>
      <StyledBoxColumn
        style={{padding: `${PD_XLG2}px ${PD_XLG}px`, background: this.theme.palette.background.paper, borderBottom: DIVIDER}}>
        <Typography variant={"h4"}>Welcome to Labeler</Typography>
        <Typography>Labeler helps you upload datasets that can be annotated by human experts for training ML & AI models.</Typography>
      </StyledBoxColumn>
      <StyledBoxColumn style={{padding: PD_XLG, gap: PD_XLG}}>
        <StyledBoxColumn>
          <Typography variant={"h5"}>Quick Links</Typography>
          <Grid container style={{marginTop: -PD_MD}}>
            {HOME_LINKS.map((link, index) =>
              <Grid
                key={`home-link-${index}`}
                xs={6} sm={4} md={3} lg={2}
                style={{padding: "2%"}}>
                <Button
                  onClick={() => this.props.path.navigate(`../${link.url}`)}
                  variant="outlined"
                  style={{
                    padding: 0,
                    width: "100%",
                    // border: "4px solid " + theme.palette.secondary.main,
                    aspectRatio: 1,
                  }}>
                  <StyledBoxColumn style={{alignItems: "center", justifyContent: "center", padding: PD_MD}}>
                    <link.iconType style={{width: SZ_SMD, height: SZ_SMD}}/>
                    <Typography variant={"h6"}>{link.text}</Typography>
                  </StyledBoxColumn>
                </Button>
              </Grid>)}
            {/*{HOME_LINKS.map((link, index) => <Grid key={`home-link-${index}`} xs={6} sm={4} md={3} lg={2} style={{padding: "2%"}}>*/}
            {/*  <Button href={link.url} style={{*/}
            {/*    padding: 0,*/}
            {/*    width: "100%",*/}
            {/*    background: lightGray,*/}
            {/*    borderRadius: 16,*/}
            {/*    aspectRatio: 1,*/}
            {/*  }}>*/}
            {/*    <StyledBoxColumn style={{alignItems: "center", justifyContent: "center", padding: PD_MD}}>*/}
            {/*      <link.iconType style={{width: SZ_SMD, height: SZ_SMD}}/>*/}
            {/*      <StyledHeadingVariant default_={6} max={6}>{link.text}</StyledHeadingVariant>*/}
            {/*    </StyledBoxColumn>*/}
            {/*  </Button>*/}
            {/*</Grid>)}*/}
          </Grid>
        </StyledBoxColumn>
        <StyledBoxColumn>
          <Typography variant={"h5"}>Recents</Typography>
        </StyledBoxColumn>
      </StyledBoxColumn>
    </>;
  }
}